export enum InputVariantTypes {
  DEFAULT = 'DEFAULT',
  SNOWDROP = 'SNOWDROP',
}
